"use client";
import { FormattedMessage } from "@/i18n/i18n-client";
import { Section } from "../../../shared/layout";
import type { ContactPageProps } from "../../types";
import { StoreTemplate } from "../../TemplateLoader";

const ContactPage: React.FC<ContactPageProps> = () => {
  const Template = StoreTemplate.get();

  return (
    <>
      <Template.PageHeader
        pageTitle={<FormattedMessage defaultMessage="Contact Us" id="hZOGLS" />}
      />
      <Section background="backgroundReverse">
        <Template.ContactElement />
      </Section>
    </>
  );
};

export default ContactPage;
